import { Permission } from '@today/types'

/** Which compliance actions the viewer may see (TO-232 compliance-admin-ui REQ-201). */
export interface ComplianceCapabilities {
	read: boolean
	manageErasures: boolean
	manageHolds: boolean
	manageSars: boolean
}

/** The pure permission map: an action the viewer lacks is not rendered (the API enforces it regardless). */
export const complianceCapabilities = (permissions: readonly string[]): ComplianceCapabilities => {
	const has = (permission: Permission) => permissions.includes(permission)
	return {
		read: has(Permission.COMPLIANCE_READ),
		manageErasures: has(Permission.COMPLIANCE_ERASURE_MANAGE),
		manageHolds: has(Permission.COMPLIANCE_LEGAL_HOLD_MANAGE),
		manageSars: has(Permission.COMPLIANCE_SAR_MANAGE),
	}
}
